import { BACKEND_URI } from "../entries";
import { devLog } from "../utils/loggerUtils";
import { secureAPICall } from "../utils/sessionUtils";


export const requestCreateNewUser = async ({ email, userClass, userRank, verbose = false }) => {
    const formData = new FormData();
    formData.append("email", email)
    formData.append("user_class", userClass)
    formData.append("user_rank", userRank)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/users/create-new-user", body: formData, verbose: verbose })
}


export const requestDeleteDev = async ({ userId, verbose = false }) => {
    const formData = new FormData();
    formData.append("user_id", userId)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/users/delete-dev", body: formData, verbose: verbose })
}


export const requestChangeDevCategories = async ({ userId, categories, verbose = false }) => {
    const formData = new FormData();
    formData.append("user_id", userId)
    categories.forEach((category) => {
        formData.append("categories", category)
    })
    if (categories.length === 0) {
        formData.append("categories", [])
    }

    return secureAPICall({ endpoint: BACKEND_URI + "/api/users/change-dev-categories", body: formData, verbose: verbose })
}


export const requestChangeDevResponsibilities = async ({ userId, categories, servers, verbose = false }) => {
    const formData = new FormData();
    formData.append("user_id", userId)
    servers.forEach((server) => {
        formData.append("servers", server)
    })
    if (servers.length === 0) {
        formData.append("servers", [])
    }
    categories.forEach((category) => {
        formData.append("categories", category)
    })
    if (categories.length === 0) {
        formData.append("categories", [])
    }

    return secureAPICall({ endpoint: BACKEND_URI + "/api/users/change-dev-responsibilities", body: formData, verbose: verbose })
}


export const requestPulseCheck = async ({ verbose = false }) => {

    const response = await fetch(BACKEND_URI + "/auth/pulse-check", {
        method: "GET",
        credentials: 'include'
    })
    const result = await response.json()

    if (!response.ok) {
        throw {
            status: response.status,
            message: result.detail
        }
    }

    if (verbose) {
        devLog(result.status, result.message)
        devLog(result.data)
    }
    return result.data
}



export const requestSetupPassword = async ({ token, password, verbose }) => {
    const formData = new FormData();
    formData.append("password_token", token)
    formData.append("new_password", password)


    const response = await fetch(BACKEND_URI + "/auth2/setup-password", {
        method: "POST",
        body: formData,
        mode: "cors",
    })
    const result = await response.json()
    if (!response.ok) {
        throw {
            status: response.status,
            message: result.detail
        }
    }
    if (verbose) {
        devLog(result.status, result.message)
        devLog(result)
    }
    return result

}


export const requestCheckTokenStatus = async ({ token, verbose }) => {
    const formData = new FormData();
    formData.append("password_token", token)

    const response = await fetch(BACKEND_URI + "/auth2/check-password-token", {
        method: "POST",
        body: formData,
        mode: "cors"
    })
    const result = await response.json()
    if (!response.ok) {
        throw {
            status: response.status,
            message: result.detail
        }
    }
    if (verbose) {
        devLog(result.status, result.message)
        devLog(result)
    }
    return result

}


export const requestLogin = async ({ email, password, captchaToken, verbose = false }) => {

    const formData = new FormData();
    formData.append("username", email)
    formData.append("password", password)
    formData.append("captchaToken", captchaToken)

    const response = await fetch(BACKEND_URI + "/auth/login", {
        method: "POST",
        body: formData,
        mode: "cors",
        credentials: "include"
    })
    const result = await response.json()
    if (!response.ok) {
        throw {
            status: response.status,
            message: result.detail
        }
    }
    if (verbose) {
        devLog(result.status, result.message)
        devLog(result)
    }
    return result
}

export const requestLogout = async ({ verbose = false }) => {

    const response = await fetch(BACKEND_URI + "/auth/logout", {
        method: "POST",
        body: {},
        mode: "cors",
        credentials: "include"
    })
    const result = await response.json()
    if (!response.ok) {
        throw {
            status: response.status,
            message: result.detail
        }
    }
    if (verbose) {
        devLog(result.status, result.message)
        devLog(result)
    }
    return result

}


export const requestRefresh = async ({ verbose = false }) => {
    const response = await fetch(BACKEND_URI + "/auth/refresh", {
        method: "GET",
        credentials: "include"
    })
    const result = await response.json()
    if (!response.ok) {
        throw {
            status: response.status,
            message: result.detail
        }
    }
    if (verbose) {
        devLog(result.status, result.message)
        devLog(result)
    }
    return result.data
}


export const requestIdToken = async ({ userId, verbose = false }) => {
    const formData = new FormData()
    formData.append("user_id", userId)
    const response = await fetch(BACKEND_URI + "/auth/get_id_token", {
        method: "POST",
        body: formData,
        credentials: "include"
    })
    const result = await response.json()
    if (!response.ok) {
        throw {
            status: response.status,
            message: result.detail
        }
    }
    if (verbose) {
        devLog(result.status, result.message)
        devLog(result)
    }
    return result.data.id_token

}


export const requestDevs = async ({ verbose = false }) => {
    return secureAPICall({ endpoint: BACKEND_URI + "/api/users/fetch-devs", verbose: verbose })
}

export const requestDev = async ({ userId, verbose = false }) => {
    const formData = new FormData()
    formData.append("user_id", userId)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/users/fetch-dev", body: formData, verbose: verbose })
}


export const requestDevsActiveTicketNumbers = async ({devIds, verbose = false }) => {
    const formData = new FormData();
    devIds.forEach((devId) => {
        formData.append("dev_ids", devId)
    })
    if (devIds.length === 0) {
        formData.append("dev_ids", [])
    }
    return secureAPICall({ endpoint: BACKEND_URI + "/api/users/fetch-devs-active-ticket-numbers", body: formData, verbose: verbose})
}


export const requestCheckEmailExists = async ({ email, verbose = false }) => {
    const formData = new FormData();
    formData.append("email", email)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/users/check-new-user-email", body: formData, verbose: verbose })
}


export const requestChangePassword = async ({ devId, password, rePassword, verbose = false }) => {
    const formData = new FormData()
    formData.append("dev_id", devId)
    formData.append("password", password)
    formData.append("re_password", rePassword)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/users/change-password", body: formData, verbose: verbose })
}


export const requestLeaveTempTicket = async ({ ticket_id, user_id, verbose = false }) => {
    const formData = new FormData()
    formData.append("ticket_id", ticket_id)
    formData.append("user_id", user_id)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/tickets/leave-temp-ticket", body: formData, verbose: verbose })
}


export const requestDisableUser = async ({ id, verbose = false }) => {
    const formData = new FormData()
    formData.append("id", id)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/users/disable-user", body: formData, verbose: verbose })
}


export const requestDisableUserUntil = async ({ id, date, verbose=false }) => {
    const formData = new FormData()
    formData.append("id", id)
    formData.append("date", date)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/users/disable-user-until", body: formData, verbose: verbose })
}


export const requestEnableUser = async ({ id, verbose = false }) => {
    const formData = new FormData()
    formData.append("id", id)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/users/enable-user", body: formData, verbose: verbose })
}


// Ticket intake: no new tickets, the user still signs in.
export const requestPauseAssignmentUntil = async ({ id, date, verbose = false }) => {
    const formData = new FormData()
    formData.append("id", id)
    formData.append("date", date)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/users/pause-assignment-until", body: formData, verbose: verbose })
}


export const requestResumeAssignment = async ({ id, verbose = false }) => {
    const formData = new FormData()
    formData.append("id", id)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/users/resume-assignment", body: formData, verbose: verbose })
}


export const requestDisperseUserTickets = async ({ id, verbose = false}) => {
    const formData = new FormData()
    formData.append("id", id)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/users/disperse-user-tickets", body: formData, verbose: verbose})
}